import { render, staticRenderFns } from "./ActualitePat.vue?vue&type=template&id=378d5eea&scoped=true"
import script from "./ActualitePat.vue?vue&type=script&lang=js"
export * from "./ActualitePat.vue?vue&type=script&lang=js"
import style0 from "./ActualitePat.vue?vue&type=style&index=0&id=378d5eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d5eea",
  null
  
)

export default component.exports